import React, { useContext } from 'react';
import { ImageCropperContext } from '../../../../libs/gs-component-image-upload';
import { PhotoActionButton } from '../PhotoActionButton';

interface Props {
  trackCoverPhotoRotation?: () => void;
}
export const RotationControl: React.FC<Props> = ({ trackCoverPhotoRotation }) => {
  const { rotateImageRight } = useContext(ImageCropperContext);
  const rotateImage = () => {
    rotateImageRight();
    trackCoverPhotoRotation && trackCoverPhotoRotation();
  };
  return (
    <PhotoActionButton
      flipIcon
      iconName="refresh"
      onClickHandler={rotateImage}
      ariaLabel={'Rotate Clockwise'}
      iconLabel={'Rotate'}
    />
  );
};
